import type { PaginationRange } from '../types/negociacoesUiTypes';

interface BuildPaginationRangeInput {
  page: number;
  limit: number;
  total: number;
}

export const buildPaginationRange = ({
  page,
  limit,
  total,
}: BuildPaginationRangeInput): PaginationRange => {
  if (total <= 0) {
    return {
      start: 0,
      end: 0,
      total: 0,
      text: '0–0 de 0',
    };
  }

  const safePage = page < 1 ? 1 : page;
  const safeLimit = limit < 1 ? 1 : limit;
  const start = (safePage - 1) * safeLimit + 1;
  const end = Math.min(safePage * safeLimit, total);

  return {
    start,
    end,
    total,
    text: `${start}–${end} de ${total}`,
  };
};
